/* DocumentPositionState constants */


export const ON_CREATED = '2221691371000';
export const ON_REJECTED = '2222044710000';
export const ON_COMPLETED = '2222043485000';

